import { FC, useState } from "react";
import useI18n from "../../../../../hooks/useTranslations";
import Button from "../../../../ui/Button";
import ModalDialog from "../../../../ui/ModalDialog";
import { ItemExtraForm } from "./ItemExtraForm";

type SelectOption = {
  id: string;
  label: string;
};

interface CreateItemExtraModalDialogButtonProps {
  fixedItem?: SelectOption;
  fixedExtraItem?: SelectOption;
  onCreated?: (id: string) => void;
}

export const CreateItemExtraModalDialogButton: FC<CreateItemExtraModalDialogButtonProps> = ({
  fixedItem,
  fixedExtraItem,
  onCreated,
}) => {
  const i18n = useI18n();
  const [showNewItemDialog, setShowNewItemDialog] = useState(false);

  return (
    <>
      <Button buttonProps={{ onClick: () => setShowNewItemDialog(true) }}>{i18n.translation.common.createNew}</Button>
      {showNewItemDialog && (
        <ModalDialog onClose={() => setShowNewItemDialog(false)} title={i18n.translation.itemExtras.new}>
          <ItemExtraForm
            fixedItem={fixedItem}
            fixedExtraItem={fixedExtraItem}
            onClose={() => setShowNewItemDialog(false)}
            onCreated={onCreated}
          />
        </ModalDialog>
      )}
    </>
  );
};
